import { Link } from "react-router-dom";

const PageNotFound = () => {
    return (
        <div className="h-screen flex flex-col justify-center items-center">
            <h1 className="text-2xl font-bold">404 - Page Not Found</h1>
            <p className="text-xl font-medium">The page you are looking for was either moved or does not exist.</p>
            <Link to={"/dashboard"} >Go Back Home</Link>
        </div>
    )
}

export default PageNotFound;